import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updateFeedFilterRateCell } from '../../actions/feed-filters/grid';
import { ChangeFeedFilterRatePayload, changeFeedFiltersRate } from '../../actions/feed-filters/rate-form';
import { cancelCellEdit } from '../../actions/grid-screen';
import {
    FeedFilterRateCellEditor,
    FeedFilterRateCellEditorProps
} from '../../components/FeedFilterRateCellEditor/FeedFilterRateCellEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { FeedFilterRateType } from '../../typings/feedFilters';
import { State } from '../../typings/state';

export type StateProps = Pick<FeedFilterRateCellEditorProps, 'isSaving' | 'error'>;

export interface DispatchProps {
    onSave: (rateType: FeedFilterRateType, rate?: number) => void;
    onCancel: () => void;
    onInitialValuesSet: (payload: ChangeFeedFilterRatePayload) => void;
}

export interface OwnProps {
    feedFilterId: string;
    cellName: string;
    rate?: number;
    fixedRateType: FeedFilterRateType;
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData } = state.grid;
    const { feedFilterId, cellName } = ownProps;
    const { view } = selectGridSourceParams(state);

    return getEditCellData(editCellsData, feedFilterId, cellName, view);
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { cellName, feedFilterId } = ownProps;

    return {
        onSave: (rateType: FeedFilterRateType) => {
            dispatch(updateFeedFilterRateCell(feedFilterId, cellName, rateType));
        },
        onCancel: () => {
            dispatch(cancelCellEdit(feedFilterId, cellName));
        },
        onInitialValuesSet(payload: ChangeFeedFilterRatePayload) {
            dispatch(changeFeedFiltersRate(payload));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): FeedFilterRateCellEditorProps => {
    const { rate, fixedRateType, cellName, feedFilterId } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        rate,
        fixedRateType,
        cellName,
        feedFilterId
    };
};

export const FeedFilterRateCellEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    FeedFilterRateCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(FeedFilterRateCellEditor);
